<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
				<el-row>
					<el-col :xs="24" :sm="12" :md="6" :lg="6">
						<el-form-item label-width="75px">
							<div slot="label">角色</div>
							<el-select v-model="searchEmp.role_name" placeholder="请选择" style="width:100%">
								<el-option v-for="item in roleList" :key="item.id" :label="item.role_name" :value="item.role_name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="11" style="float:right">
						<el-row style="text-align:end;width:100%">
							<el-button type="info" @click="clean_btn">重置</el-button>
							<el-button type="primary" @click="search_btn">查询</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-form>

			<Total :total="total"></Total>

			<!-- 表格 -->

			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F1F2F7', color: '#606266' }">
				<el-table-column prop="role_name" label="角色" align="center">
				</el-table-column>
				<el-table-column prop="menu" label="功能权限" align="center">
				</el-table-column>
			</el-table>

			<!-- 分页 -->

			<!-- <div class="page">  与后端沟通 - 去除分页
				<el-pagination v-if="tableData.length != 0" class="fy" style="" layout="prev, pager, next" :total="total"
					:page-size="pageData.page_size" :current-page="pageData.page_no" @current-change="current_change" background>
				</el-pagination>
			</div> -->
		</el-card>
	</div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { getRolesList } from '@/api/manage'
let that
export default {
	name: "RoleVue",
	data() {
		return {
			breadcrumbList: [
				{ name: "角色管理", path: "role" },
			],
			searchEmp: {},
			tableData: [],
			total: 0,
			pageData: {
				page_no: 1,  //现在
				page_size: 10, //每页条数
			},
			roleList: [], // 角色组
			loading: true
		}
	},
	async created() {
		that = this
		this.info()
	},
	methods: {
		info() {
			this.$axios.all([
				getRolesList(),
				getRolesList(this.searchEmp)
			]).then(this.$axios.spread(
				(roleList, res) => {
					that.roleList = roleList
					that.total = res.length
					res.forEach(item => {
						item.menu = item.menu.join(`/`)
					})
					that.tableData = res
				}
			))
		},
		clean_btn() { // 重置
			this.searchEmp = {}
			this.info()
		},
		search_btn() {
			this.pageData.page_no = 1
			this.info()
		},
	},
	components: { Total }
}
</script>

<style lang="less" scoped>
.revise {
	border-radius: 16px;
	font-size: 16px;
	font-weight: 500;
	text-align: center;
}
</style>